var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomizeColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99935 13.2666V2.73325C8.99935 1.73325 9.42602 1.33325 10.486 1.33325H13.1793C14.2393 1.33325 14.666 1.73325 14.666 2.73325V13.2666C14.666 14.2666 14.2393 14.6666 13.1793 14.6666H10.486C9.42602 14.6666 8.99935 14.2666 8.99935 13.2666Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33309 8.60004V2.73337C1.33309 1.73337 1.75976 1.33337 2.81976 1.33337H5.51309C6.57309 1.33337 6.99976 1.73337 6.99976 2.73337V8.60004C6.99976 9.60004 6.57309 10 5.51309 10H2.81976C1.75976 10 1.33309 9.60004 1.33309 8.60004Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizeColumn);
export default __webpack_public_path__ + "static/media/customizeColumn.cfcbeb2c235b0fc7febe366337b97ab9.svg";
export { ForwardRef as ReactComponent };